import { render, staticRenderFns } from "./CtaDescription.vue?vue&type=template&id=4e22a256&scoped=true&"
import script from "./CtaDescription.vue?vue&type=script&lang=js&"
export * from "./CtaDescription.vue?vue&type=script&lang=js&"
import style0 from "./CtaDescription.vue?vue&type=style&index=0&id=4e22a256&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e22a256",
  null
  
)

export default component.exports